export const common = {
  // Navigation
  'nav.features': 'Veçoritë',
  'nav.howItWorks': 'Si funksionon',
  'nav.pricing': 'Çmimet',
  'nav.faq': 'Pyetje të shpeshta',
  'nav.aboutUs': 'Rreth nesh',
  'nav.getStarted': 'Fillo',

  // About Us Section
  'aboutUs.badge': 'Rreth nesh',
  'aboutUs.title': 'Rreth nesh',
  'aboutUs.line1': 'Idetë janë të lira.',
  'aboutUs.line2': 'Kapitali jo. Koha aq më pak.',
  'aboutUs.paragraph1':
    'IdeaOracle.ai u themelua sepse shumica e ideve të biznesit nuk dështojnë për mungesë guximi – por për mungesë sinqeriteti. Shumë konfirmim. Shumë pak realitet.',
  'aboutUs.belief1a': 'Ne nuk besojmë në bujë.',
  'aboutUs.belief1b': 'Ne besojmë në logjikën e tregut.',
  'aboutUs.belief2a': 'Ne nuk besojmë në motivim.',
  'aboutUs.belief2b': 'Ne besojmë në kërkesë, konkurrencë dhe diferencim.',
  'aboutUs.mission1': 'Detyra jonë nuk është t\'i bëjmë idetë të duken mirë.',
  'aboutUs.mission2': 'Detyra jonë është të zbulojmë qëndrueshmërinë e tyre.',
  'aboutUs.analysis':
    'IdeaOracle.ai analizon nishet e biznesit për mekanikën strukturore të tregut, kërkesën realiste, intensitetin konkurrues dhe realizueshmërinë. Jo emocionale. Jo optimiste. Por e matur.',
  'aboutUs.failure1': 'Shumica e ideve dështojnë.',
  'aboutUs.failure2': 'Jo sepse themeluesit janë të paaftë –',
  'aboutUs.failure3': 'por sepse askush nuk ishte mjaft i qartë paraprakisht.',
  'aboutUs.clarity': 'Ne ekzistojmë për të ofruar atë qartësi.',
  'aboutUs.value1': 'E pakëndshme.',
  'aboutUs.value2': 'E drejtpërdrejtë.',
  'aboutUs.value3': 'Konsistente.',
  'aboutUs.confirm': 'Nëse një ide ka substancë, ne e konfirmojmë.',
  'aboutUs.deny': 'Nëse jo, ne e themi gjithashtu.',
  'aboutUs.noApplause': 'Pa duartrokitje.',
  'aboutUs.noSugarcoating': 'Pa zbukurime.',
  'aboutUs.noTheater': 'Pa teatër.',

  // Hero Section
  'hero.badge': 'AI vendimmarrëse për nishe biznesi',
  'hero.title1': 'Idetë janë të lira.',
  'hero.title2': 'Vendimet e gabuara nuk janë.',
  'hero.subtitle': 'Një AI që vlerëson nishën tuaj të biznesit',
  'hero.subtitleLine2': 'para se të investoni.',
  'hero.cta': 'Kontrollo idenë',
  'hero.ctaSecondary': 'Si funksionon',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Kredite për kërkesë',
  'hero.stat2Value': 'Nga 7',
  'hero.stat2Label': 'Nivele vlerësimi',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'I ndershëm dhe privat',

  // Features Section
  'features.title1': 'Veçori të fuqishme për',
  'features.title2': 'biznese',
  'features.title3': 'moderne',
  'features.honestVerdict.title': 'Vlerësim i ndershëm, jo një rezultat hype',
  'features.honestVerdict.description': 'Vendime të qarta mirë/mesatar/i dobët mbështetur në të dhëna reale të tregut dhe hulumtim të konkurrentëve. Pa vlerësime 9/10 të krijuara për të lajkatuar çdo ide.',
  'features.fullJourney.title': 'Nga testi i idesë te Builder Report',
  'features.fullJourney.description': 'Validoje në chat, thellohu në analizën e tregut, eksporto një Builder Report me 25–75 faqe me persona, financa, go-to-market dhe pitch deck.',
  'features.multilingual.title': '21 gjuhë, të dhëna lokale të tregut',
  'features.multilingual.description': 'Nga një NVM zvicerane te një themelues solo në São Paulo — AI përgjigjet në gjuhën tënde, me burime nga tregu yt.',

  // How It Works
  'howItWorks.title': 'Si funksionon',
  'howItWorks.subtitle': 'Katër hapa drejt qartësisë për nishën tuaj të biznesit.',
  'howItWorks.step1Title': 'Zgjidhni një plan',
  'howItWorks.step1Desc': 'Starter, Pro ose Builder - në varësi të thellësisë së rishikimit tuaj.',
  'howItWorks.step2Title': 'Pyesni AI-në',
  'howItWorks.step2Desc': 'Bëni pyetjet tuaja për nishën. Çdo kërkesë kushton 30 kredite.',
  'howItWorks.step3Title': 'Merrni vendim të sinqertë',
  'howItWorks.step3Desc': 'AI vlerëson: E mirë, Mesatare ose E keqe. Pa zbukurime.',
  'howItWorks.step4Title': 'Merrni një vendim',
  'howItWorks.step4Desc': 'Tani e dini nëse ia vlen të vazhdoni.',

  // Pricing
  'pricing.title': 'Çmimet',
  'pricing.subtitle': 'Zgjidhni planin që i përshtatet thellësisë së rishikimit tuaj.',
  'pricing.yearlyDiscount': 'Abonim vjetor:',
  'pricing.yearlyDiscountValue': 'Zbritje -20%',
  'pricing.perMonth': 'në muaj',
  'pricing.selectPlan': 'Zgjidhni planin',
  'pricing.mostPopular': 'Më i popullarizuari',
  'pricing.footer':
    'Të gjitha çmimet në CHF. Kreditet zbriten vetëm për përgjigje të suksesshme AI.',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Për teste fillestare realiteti.',
  'pricing.starter.credits': '2,500 kredite',
  'pricing.starter.feature1': 'Gjenero ide nishe',
  'pricing.starter.feature2': 'Përmirëso nishën',
  'pricing.starter.feature3': 'Kontroll realiteti i tregut',
  'pricing.starter.feature4': 'Vlerësim konkurrence',
  'pricing.starter.feature5': 'Vlerësim kohor',
  'pricing.starter.feature6': 'Vendim i sinqertë',
  'pricing.starter.feature7': 'Sesione private',
  'pricing.starter.feature8': 'Historik dhe eksport',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Për rishikim më të thellë.',
  'pricing.pro.credits': '5,000 kredite',
  'pricing.pro.feature1': 'Të gjitha veçoritë Starter',
  'pricing.pro.feature2': 'Më shumë kredite për rishikim intensiv',
  'pricing.pro.feature3': 'Sugjerime përmirësimi',
  'pricing.pro.feature4': 'Nishe alternative',
  'pricing.pro.feature5': 'Analizë e detajuar e tregut',
  'pricing.pro.feature6': 'Mbështetje me prioritet',
  'pricing.pro.feature7': 'Filtra të avancuar',
  'pricing.pro.feature8': 'Të preferuara sesioni',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Ide → Briefing zhvilluesi.',
  'pricing.builder.credits': 'Kredite të pakufizuara',
  'pricing.builder.feature1': 'Të gjitha veçoritë Pro',
  'pricing.builder.feature2': 'Kërkesa të pakufizuara AI',
  'pricing.builder.feature3': 'Modaliteti Builder: Briefing zhvilluesi',
  'pricing.builder.feature4': 'Përmbledhje e strukturuar e projektit',
  'pricing.builder.feature5': 'Rrjedha e përdoruesit dhe funksione kryesore',
  'pricing.builder.feature6': 'Shënime teknike',
  'pricing.builder.feature7': 'Përcakto jo-objektiva',
  'pricing.builder.feature8': 'Kufizim i normës së përdorimit të drejtë',
  'pricing.builder.limitNote': 'Kufizim përdorimi i drejtë',
  'pricing.monthlyReset': 'Rivendosje mujore',

  // Modal
  'pricing.modal.selected': 'zgjedhur',
  'pricing.modal.comingSoon':
    'Regjistrimi dhe përpunimi i pagesave do të jetë i disponueshëm së shpejti.',
  'pricing.modal.patience':
    "Po punojmë për t'ju ofruar një përvojë të sigurt dhe të qetë. Ju lutemi të jeni të durueshëm.",
  'pricing.modal.understood': 'E kuptuar',

  // FAQ
  'faq.title': 'Pyetje të shpeshta',
  'faq.subtitle': 'Përgjigjur me sinqeritet dhe kritikisht.',
  'faq.q1': 'Çfarë bën konkretisht IdeaOracle.ai?',
  'faq.a1': 'IdeaOracle.ai vlerëson idetë e biznesit dhe nishet për logjikën e tregut, kërkesën reale, konkurrencën, diferencimin dhe realizueshmërinë.\nNëse ka substancë, tregojmë si mund të mprihet strategjikisht.\nNëse jo, e themi.',
  'faq.q2': 'A gjeneroni edhe ide?',
  'faq.a2': 'Po.\nPor jo verbërisht.\nZhvillojmë qasje bazuar në logjikën e tregut – jo në motivim apo bujë trendesh.',
  'faq.q3': 'A optimizoni modelet e biznesit?',
  'faq.a3': 'Po – nëse ka potencial.\nNuk lustrojmë iluzione.\nI bëjmë konceptet e qëndrueshme më rezistente.',
  'faq.q4': 'Çfarë ju dallon nga mjetet e tjera AI?',
  'faq.a4': 'Mjetet e tjera ofrojnë frymëzim.\nNe ofrojmë vlerësim.\nFokusi është te realizmi, jo te entuziazmi.',
  'faq.q5': 'A është kjo garanci për sukses?',
  'faq.a5': 'Jo.\nReduktojmë vendimet e gabuara – nuk eliminojmë rrezikun.',
  'faq.q6': 'Për kë është IdeaOracle.ai?',
  'faq.a6': 'Themelues para nisjes\nSipërmarrës para zgjerimit\nSide-builder para investimit të kohës\nInvestitorë para shqyrtimit\n\nShkurt: Për njerëz që duan qartësi para kapitalit.',
  'faq.q7': 'Po nëse kërkoj vetëm konfirmim?',
  'faq.a7': 'Atëherë IdeaOracle.ai nuk është mjeti i duhur.',
  'faq.q8': 'Sa e sinqertë është analiza?',
  'faq.a8': 'Aq e sinqertë sa lejojnë të dhënat dhe mekanika e tregut.\nAsnjë eufori. Asnjë mëshirë.',
  'faq.q9': 'A zëvendësoni hulumtimin e tregut?',
  'faq.a9': 'Jo.\nNe jemi një para-vlerësim strategjik – jo një studim i plotë tregu.',
  'faq.q10': 'Pse kaq pa kompromis?',
  'faq.a10': 'Sepse dështimi është i shtrenjtë.\nSinqeriteti jo.',

  // Footer
  'footer.description':
    'Kjo platformë nuk ju ndihmon të ndiheni mirë - por të vendosni drejt.',
  'footer.product': 'Produkti',
  'footer.howItWorks': 'Si funksionon',
  'footer.pricing': 'Çmimet',
  'footer.faq': 'Pyetje të shpeshta',
  'footer.legal': 'Ligjore',
  'footer.privacy': 'Privatësia',
  'footer.terms': 'Kushtet',
  'footer.imprint': 'Imprint',
  'footer.support': 'Mbështetje',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentacion',
  'footer.copyright': '© 2025 IdeaOracle.ai. Të gjitha të drejtat e rezervuara.',

  // Header & Sidebar
  'dashboard.header.title': 'Paneli',
  'dashboard.sidebar.overview': 'Përmbledhje',
  'dashboard.sidebar.newAnalysis': 'Asistent AI',
  'dashboard.sidebar.history': 'Historiku',
  'dashboard.sidebar.credits': 'Kredite',
  'dashboard.sidebar.settings': 'Cilësimet',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Mirë se u kthyet, {{name}}',
  'dashboard.overview.subtitle': 'Këtu është një përmbledhje e shpejtë e aktivitetit tuaj',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Kredite të mbetura',
  'dashboard.stats.totalAnalyses': 'Analiza totale',
  'dashboard.stats.goodRatings': 'Vlerësime pozitive',
  'dashboard.stats.nextReset': 'Rivendosja e ardhshme në',
  'dashboard.stats.days': 'ditë',

  // Quick Actions
  'dashboard.quickActions.title': 'Veprime të shpejta',
  'dashboard.quickActions.checkNewIdea': 'Kontrollo një ide',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analizoni një ide biznesi ekzistuese',
  'dashboard.quickActions.generateIdea': 'Gjenero një ide',
  'dashboard.quickActions.generateIdeaDesc': 'Gjeni një nishë të re fitimprurëse',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc':
    'Ktheni një ide në një briefing të gatshëm për zhvillues',
  'dashboard.quickActions.premiumOnly': 'Vetëm Builder',

  // Chat Header
  'chat.title': 'Asistent AI nishe',
  'chat.subtitle': 'Bëni pyetje për nishe. Vlerësoj kritikisht dhe me sinqeritet.',
  'chat.creditsLabel': 'Kredite',

  // Chat Welcome
  'chat.welcomeTitle': 'Mirë se vini te Asistenti AI nishe',
  'chat.welcomeDesc':
    'Përshkruani idenë tuaj ose pyesni për një nishë. Do ta vlerësoj me sinqeritet: E mirë, Mesatare ose E keqe.',
  'chat.aiWelcome':
    "Përshëndetje! Përshkruani idenë tuaj ose më pyesni për një nishë. Do t'ju jap një vlerësim të qartë dhe të sinqertë.",

  // Chat Suggestions
  'chat.suggestion1': 'Gjej një nishë fitimprurëse për mua.',
  'chat.suggestion2': 'Kam një ide - vlerësoje me sinqeritet.',
  'chat.suggestion3': 'Cilat nishe kanë potencial tani?',
  'chat.suggestion4': 'Përmirëso këtë nishë dhe bëje më specifike.',

  // Chat Actions
  'chat.newConversation': 'Bisedë e re',
  'chat.today': 'Sot',
  'chat.yesterday': 'Dje',
  'chat.thisWeek': 'Këtë javë',
  'chat.thisMonth': 'Këtë muaj',
  'chat.older': 'Më të vjetra',
  'chat.messages': 'mesazhe',
  'chat.renameConversation': 'Riemërto',
  'chat.deleteConversation': 'Fshi',
  'chat.cancel': 'Anulo',
  'chat.rename': 'Riemërto',
  'chat.delete': 'Fshi',
  'chat.favorite': 'Shto te të preferuarat',
  'chat.unfavorite': 'Hiq nga të preferuarat',
  'chat.searchSessions': 'Kërko biseda...',
  'chat.noResults': 'Nuk u gjetën rezultate',
  'chat.noSessions': 'Ende nuk ka biseda',
  'chat.enterNewName': 'Fut emër të ri...',
  'chat.deleteConfirmMessage':
    'Jeni të sigurt që dëshironi të fshini këtë bisedë? Ky veprim nuk mund të zhbëhet.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Shkruani pyetjen tuaj… (kushton 30 kredite)',
  'chat.send': 'Dërgo',
  'chat.voice': 'Fol',
  'chat.listeningPlaceholder': 'Po dëgjoj... Flisni tani.',
  'chat.stopListening': 'Ndalo regjistrimin',
  'chat.recording': 'Duke regjistruar...',
  'chat.speechNotSupported': 'Njohja e të folurit nuk mbështetet nga shfletuesi juaj.',
  'chat.microphonePermissionDenied':
    'Qasja në mikrofon u refuzua. Ju lutemi lejoni qasjen në cilësimet e shfletuesit tuaj.',
  'chat.errorNotEnoughCredits':
    'Nuk ka kredite të mjaftueshme. Ju lutemi përmirësoni planin tuaj ose prisni rivendosjen e ardhshme.',
  'chat.errorAiFailed': 'Përgjigja AI dështoi. Nuk u zbritën kredite.',
  'chat.errorRateLimit': 'Shumë kërkesa. Ju lutemi prisni një moment.',

  // Ratings
  'rating.good': 'E mirë',
  'rating.medium': 'Mesatare',
  'rating.bad': 'E keqe',

  // Auth Page
  'auth.branding.headline1': 'Jo çdo ide është e mirë.',
  'auth.branding.headline2': 'Ne ju themi me sinqeritet.',
  'auth.branding.subtitle':
    'Një AI vendimmarrëse për nishe biznesi. E qartë. Kritike. Pa zbukurime.',
  'auth.benefits.privacy.title': '100% Private',
  'auth.benefits.privacy.desc':
    'Idetë tuaja mbeten plotësisht private dhe të sigurta.',
  'auth.benefits.honest.title': 'AI e Sinqertë',
  'auth.benefits.honest.desc':
    'Pa zbukurime – vetëm reagime të qarta dhe kritike.',
  'auth.benefits.fast.title': 'Rezultate të Shpejta',
  'auth.benefits.fast.desc':
    'Merrni qartësi për nishën tuaj në minuta.',
  'auth.trust.users': 'Përdorues Aktivë',
  'auth.trust.ideas': 'Ide të Analizuara',
  'auth.trust.rating': 'Vlerësim',
  'auth.login.title': 'Hyr',
  'auth.login.headline': 'Mirë se u kthyet',
  'auth.login.subtitle': 'Hyni për të vazhduar udhëtimin tuaj.',
  'auth.login.forgotPassword': 'Keni harruar fjalëkalimin?',
  'auth.login.submit': 'Hyr',
  'auth.login.noAccount': 'Nuk keni llogari?',
  'auth.login.signUp': 'Regjistrohu',
  'auth.register.title': 'Regjistrohu',
  'auth.register.headline': 'Krijoni llogarinë tuaj',
  'auth.register.subtitle':
    'Filloni të analizoni idetë tuaja të biznesit sot.',
  'auth.register.submit': 'Krijo Llogari',
  'auth.register.hasAccount': 'Keni tashmë një llogari?',
  'auth.register.signIn': 'Hyr',
  'auth.fields.name': 'Emri i Plotë',
  'auth.fields.email': 'Adresa Email',
  'auth.fields.password': 'Fjalëkalimi',
  'auth.fields.confirmPassword': 'Konfirmo Fjalëkalimin',
  'auth.fields.selectPlan': 'Zgjidhni planin tuaj',
  'auth.placeholders.name': 'Futni emrin tuaj',
  'auth.placeholders.email': 'Futni emailin tuaj',
  'auth.placeholders.password': 'Futni fjalëkalimin tuaj',
  'auth.placeholders.confirmPassword': 'Konfirmoni fjalëkalimin tuaj',
  'auth.terms.accept': 'Pranoj',
  'auth.terms.terms': 'Kushtet dhe Rregullat',
  'auth.privacy.accept': 'Pranoj',
  'auth.privacy.policy': 'Politikën e Privatësisë',
  'auth.errors.nameRequired': 'Emri është i detyrueshëm',
  'auth.errors.emailRequired': 'Emaili është i detyrueshëm',
  'auth.errors.emailInvalid': 'Ju lutemi futni një email të vlefshëm',
  'auth.errors.passwordRequired': 'Fjalëkalimi është i detyrueshëm',
  'auth.errors.passwordLength':
    'Fjalëkalimi duhet të ketë të paktën 8 karaktere',
  'auth.errors.passwordMismatch': 'Fjalëkalimet nuk përputhen',
  'auth.loading': 'Ju lutemi prisni...',
  'auth.or': 'ose vazhdoni me',
  'auth.social.google': 'Vazhdoni me Google',
  'auth.social.apple': 'Vazhdoni me Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'Qasje falas për 3 ditë',
  'pricing.trial.credits': '250 kredite',
  'pricing.trial.free': 'Falas',
  'pricing.trial.duration': 'Pa pagesë për 3 ditë',
  'pricing.trial.cta': 'Nis provën falas',
  'pricing.trial.feature1': '250 kredite për të eksploruar AI-në',
  'pricing.trial.feature2': 'Qasje e plotë për 3 ditë',
  'pricing.trial.feature3': 'Pa kartë krediti',
  'pricing.trial.feature4': 'Anuloje në çdo kohë',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10 000 kredite + raport Builder me 25 faqe',
  'pricing.gold.credits': '10 000 kredite',
  'pricing.gold.feature1': '10 000 kredite',
  'pricing.gold.feature2': 'Raport Builder me 25 faqe',
  'pricing.gold.feature3': 'Të gjitha veçoritë Starter dhe Pro',
  'pricing.gold.feature4': 'Analizë tregu dhe përmbledhje',
  'pricing.gold.feature5': 'Mundësi, rreziqe, rekomandime',
  'pricing.gold.feature6': 'Shkarko PDF',
  'pricing.gold.feature7': 'Mbështetje',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15 000 kredite + raport Builder me 100 faqe',
  'pricing.platinum.credits': '15 000 kredite',
  'pricing.platinum.feature1': '15 000 kredite',
  'pricing.platinum.feature2': 'Raport Builder me 100 faqe',
  'pricing.platinum.feature3': 'Të gjitha veçoritë Gold',
  'pricing.platinum.feature4': 'Mënyra Builder: brifingje për zhvilluesit',
  'pricing.platinum.feature5': 'Përmbledhje e strukturuar',
  'pricing.platinum.feature6': 'Analizë e avancuar e tregut',
  'pricing.platinum.feature7': 'Mbështetje',

  // Pricing UI
  'pricing.monthly': 'Mujor',
  'pricing.yearly': 'Vjetor',
  'pricing.savings': 'kursim',
  'pricing.billedYearly': 'Faturim vjetor',

  // Hero trial CTA
  'hero.trialTitle': 'Nis provën tënde falas',
  'hero.creditsLabel': 'Kredite',
  'hero.trialTagline': 'Provo asistentin tonë AI falas për 3 ditë',
  'hero.trialCta': 'Regjistrohu & merr 250 kredite',
  'hero.trialNoCard': 'Pa kartë krediti. Pa detyrim.',

  // Admin
  'admin.dashboard.tabs.plans': 'Planet',

  // Credit top-up
  'dashboard.credits.topup.button': 'Mbush kreditet',
  'dashboard.credits.topup.buttonTitle': 'Bli më shumë kredite pa ndryshuar planin',
  'dashboard.credits.topup.title': 'Mbush kreditet',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 për kredit — pa ndryshim plani',
  'dashboard.credits.topup.quickAmounts': 'Zgjedhje e shpejtë',
  'dashboard.credits.topup.custom': 'E personalizuar',
  'dashboard.credits.topup.totalLabel': 'Totali',
  'dashboard.credits.topup.creditsLabel': 'Kredite',
  'dashboard.credits.topup.confirm': 'Bli tani',
  'footer.disclaimer': 'Mohim përgjegjësie',
  'legal.backToHome': 'Kthehu te faqja kryesore',
  'legal.lastUpdated': 'Përditësuar së fundmi',
  'legal.allRightsReserved': 'Të gjitha të drejtat e rezervuara.',
  'legal.authoritativeNotice': 'Një version i lokalizuar në gjuhën tuaj nuk është ende i disponueshëm. Teksti autoritar anglisht është paraqitur më poshtë.',
  'legal.translationNotice': 'Ky është një përkthim për lehtësi. Versioni anglisht është origjinali juridikisht i detyrueshëm.',
};

export default common;
